var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 49,
    viewBox: "0 0 55 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0195 34.7812V32.1074H3.32947L3.30273 42.8027C3.30273 45.7707 5.68244 48.1504 8.65039 48.1504H46.084C49.0519 48.1504 51.4316 45.7707 51.4316 42.8027V32.1074H32.7148V34.7812H22.0195ZM48.7578 10.7168H38.0358V5.36914L32.6881 0.0214844H21.9928L16.6451 5.36914V10.7168H5.97656C3.03535 10.7168 0.628906 13.1232 0.628906 16.0645V24.0859C0.628906 27.0539 3.00861 29.4336 5.97656 29.4336H22.0195V24.0859H32.7148V29.4336H48.7578C51.699 29.4336 54.1055 27.0271 54.1055 24.0859V16.0645C54.1055 13.1232 51.699 10.7168 48.7578 10.7168ZM32.7148 10.7168H22.0195V5.36914H32.7148V10.7168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.8d89256b08794e7d31fb2fec3990ea2d.svg";
export { ForwardRef as ReactComponent };